/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_auth_invite_already_accepted = /** @type {(inputs: {}) => string} */ () => {
	return `Ya has aceptado esta invitación`
};

const en_auth_invite_already_accepted = /** @type {(inputs: {}) => string} */ () => {
	return `You have already accepted this invitation`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const auth_invite_already_accepted = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_invite_already_accepted(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("auth_invite_already_accepted", locale)
	if (locale === "es") return es_auth_invite_already_accepted(inputs)
	return en_auth_invite_already_accepted(inputs)
};
export { auth_invite_already_accepted as "auth.invite.already_accepted" }